import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@mui/styles';
import AppError from '../../ErrorApp/ErrorApp';

const useStyles = makeStyles(() => ({
  contentInner: {
    flexGrow: 1,
  },
  content: {
    position: 'relative',
  },

  overrides: {
    listItemText: {
      fontSize: '2px',
    },
    MuiTypography: {
      body1: {
        color: 'orange',
        fontSize: '2px',
      },
    },
  },
}));

const Body = ({ children }) => {
  const classes = useStyles();

  return (
    <main className={classes.content}>
      <div className={classes.contentInner}>{children}</div>
      <AppError />
    </main>
  );
};

Body.defaultProps = {
  children: null,
};

Body.propTypes = {
  children: PropTypes.element,
};

export default Body;
